import { IApiBaseErrorResponse } from '@app/api/interfaces/api-base-error-response.interface';
import { MonthsDateRangeType } from '@app/core/date-range/enums/months-date-range-type.enum';
import { IDateRange } from '@app/core/date-range/interfaces/date-range.interface';
import { ICombinedAiPredictorChartData } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-ai-predictor/interfaces/combined-ai-predictor-chart-data';
import { ILdLogger } from '@app/main/leak-detection/interfaces/ld-logger';

export enum FpLoggerNoiseAiPredictorActionType {
  GetData = 'GetData',
  GetDataSuccesses = 'GetDataSuccesses',
  GetDataError = 'GetDataError',
  ToggleChartFullscreen = 'ToggleChartFullscreen',
  UpdatePeriod = 'UpdatePeriod',
}

export interface FpLoggerNoiseAiPredictorActionGetData {
  type: FpLoggerNoiseAiPredictorActionType.GetData;
  date: string | null;
  popupMainData: ILdLogger | null;
}

export interface FpLoggerNoiseAiPredictorActionGetDataSuccesses {
  type: FpLoggerNoiseAiPredictorActionType.GetDataSuccesses;
  date: string | null;
  cacheDateRange?: IDateRange | null;
  cacheData?: ICombinedAiPredictorChartData[] | null;
  popupMainData: ILdLogger | null;
  data: ICombinedAiPredictorChartData[] | null;
}

export interface FpLoggerNoiseAiPredictorActionGetDataError {
  type: FpLoggerNoiseAiPredictorActionType.GetDataError;
  date: string | null;
  popupMainData: ILdLogger | null;
  error: IApiBaseErrorResponse;
}

export interface FpLoggerNoiseAiPredictorActionToggleChartFullscreen {
  type: FpLoggerNoiseAiPredictorActionType.ToggleChartFullscreen;
  synchronizeWithPopupId?: string;
}

export interface FpLoggerNoiseAiPredictorActionUpdatePeriod {
  type: FpLoggerNoiseAiPredictorActionType.UpdatePeriod;
  period: MonthsDateRangeType;
}

export type FpLoggerNoiseAiPredictorActions =
  | FpLoggerNoiseAiPredictorActionGetData
  | FpLoggerNoiseAiPredictorActionGetDataSuccesses
  | FpLoggerNoiseAiPredictorActionGetDataError
  | FpLoggerNoiseAiPredictorActionToggleChartFullscreen
  | FpLoggerNoiseAiPredictorActionUpdatePeriod;
